'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogSearch = require('./remote/catalogSearch');

var CataloSearch = {
    fetchCatalogsTodayCount: _catalogSearch.CatalogSearchRemote.fetchCatalogsTodayCount,
    fetchResults: _catalogSearch.CatalogSearchRemote.fetchSearchResults
};

exports.default = CataloSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogSearch.js
// module id = yR8t
// module chunks = 57